import React from 'react';
import classNames from 'classnames';

import MdRenderer from 'components/MdRenderer';
import styles from './PlaylistMarkdownPreview.module.scss';

function PlaylistMarkdownPreview({ mdString, className }) {
  return (
    <MdRenderer
      className={classNames(styles.markdown, className)}
      mdString={mdString}
      parseMathExpressions
    />
  );
}

export default PlaylistMarkdownPreview;
